module.exports = __webpack_public_path__ + "static/home-info-graphic-64aa0e88b9d551b605ca1ed4eb353b06.svg";